const STATS = [
  'minutes', 'appearances', 'goals', 'assists',
]

function factorial(value) {
  if(value === 0) return 1
  return value * factorial(value - 1)
}

function poissonCdf(lambda, value) {
  if(lambda === 0) return 0
  let sum = 0
  for(let i = 0; i <= value; i++) {
    sum += (Math.pow(lambda, i) / factorial(i))
  }

  return Math.pow(Math.E, -1 * lambda) * sum
}

function calculatePenalty(lambda, value) {
  if(lambda === 0) return 0
  return 1 - poissonCdf(lambda, value)
}

function processPlayerStats(stats = {}) {
  stats = Object.assign({}, stats)
  for(let key of STATS) {
    stats[key] = stats[key] || 0
  }

  stats.goals_and_assists = stats.goals + stats.assists
  stats.goals_and_assists_mean = stats.goals_and_assists / stats.appearances

  return stats
}

export default {
  processPlayerStats,
  calculatePenalty,
};
